// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ChangeTradingPasswordMessage } from '../Messages/ChangeTradingPasswordMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class ChangeTradingPasswordMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const message = new ChangeTradingPasswordMessage(fieldSet);
        return [message];
    }
}
